function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M4.30298 6.70573L7.77339 3.28953C7.94077 3.12477 7.94077 2.85765 7.77339 2.69291L7.36863 2.29446C7.20154 2.12999 6.93073 2.12967 6.76325 2.29376L3.99993 5.00116L1.23663 2.29376C1.06914 2.12967 0.798341 2.12999 0.631251 2.29446L0.226484 2.69291C0.0591087 2.85767 0.0591087 3.12478 0.226484 3.28953L3.69688 6.70573C3.86425 6.87047 4.13561 6.87047 4.30298 6.70573Z",
  fill: "#767A8A"
});
const SvgArrowdown = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowdown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrowdown.b88fc3c8.svg";
export { ForwardRef as ReactComponent };